import { actions, EXCHANGE_STORE_NAME } from './store';
import { transformExchangeResponse } from './utils';
import { frontendActions, generateApiStoreKey, LocationType } from '@cmctechnology/webinvest-store-frontend';
import castArray from 'lodash.castarray';
import { CmcWebApi } from '@cmctechnology/webinvest-api-client-web-trading';
import { Exchange } from '@cmctechnology/webinvest-constants';
import { Dispatch } from '@reduxjs/toolkit';

export const API_NAMES = {
  MarketStatusGet2: 'MarketStatusGet2'
};

export const getExchangeData = (exchange: Exchange) => async (dispatch: Dispatch<any>) => {
  try {
    const request: CmcWebApi.MarketInformation.MarketStatusRequest2 = {
      CountryIsoCode: exchange,
      ExcludeChartData: true,
      TimeZone: new Date().getTimezoneOffset(),
      UseCfdApi: true
    };

    const response = await frontendActions.webTradingApiCall<CmcWebApi.MarketInformation.MarketStatusModel2>(
      EXCHANGE_STORE_NAME,
      API_NAMES.MarketStatusGet2,
      request,
      dispatch,
      undefined,
      false,
      true
    );

    dispatch(actions.exchangeDataUpdated({ key: exchange, response: transformExchangeResponse(response as any, exchange) }));
  } catch {
    dispatch(
      frontendActions.apiRequestFailed({
        apiRequest: generateApiStoreKey(EXCHANGE_STORE_NAME, API_NAMES.MarketStatusGet2, exchange)
      })
    );
  }
};

export const onPoll =
  (subscriptions: (number | string)[] = []) =>
  (dispatch: Dispatch<any>) => {
    // Note: `subscriptions` are provided by default
    // this can be accessed by storeKey in the frontend store as well
    // This loop can be replaced by a single api call that supports array of subscriptions
    subscriptions.forEach((sub) => {
      dispatch(getExchangeData(sub as Exchange));
    });
  };

const MARKET_STATUS_POLL_TIMEOUT = 60_000;

export const subscribe = (location: LocationType, query: Exchange | Exchange[]) => async (dispatch: Dispatch<any>) => {
  dispatch(
    frontendActions.subscribe({
      onPoll,
      location,
      apiName: API_NAMES.MarketStatusGet2,
      storeName: EXCHANGE_STORE_NAME,
      resourceKeys: castArray(query),
      pollTimeout: MARKET_STATUS_POLL_TIMEOUT
    })
  );
};

export const unsubscribe = (location: LocationType, query: Exchange | Exchange[]) => (dispatch: Dispatch<any>) => {
  dispatch(
    frontendActions.unsubscribe({
      location,
      apiName: API_NAMES.MarketStatusGet2,
      storeName: EXCHANGE_STORE_NAME,
      resourceKeys: castArray(query)
    })
  );
};
